import { AxiosResponse } from 'axios';

import { QueryObserverOptions, useQueryClient } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/**
 * @description 본인인증 페이지 요청 api
 * @remarks 모빌리언스에서 제공하는 페이지가 text/html 타입으로 반환됨
 */
export const useRequestSelfCertificate = () => {
  const queryClient = useQueryClient();

  const requestSelfCertificate = async ({
    params,
    onSuccess,
    onError,
    queryConfig,
  }: {
    params: { mockAuthVerification: boolean };
    onSuccess?: (response: string) => void;
    onError?: (error: TypeErrorFormat) => void;
    queryConfig?: Omit<QueryObserverOptions<AxiosResponse<string>>, 'queryKey' | 'queryFn'>;
  }) => {
    const endPoint = '/labor-account/certificate-by-self';

    const query = queryClient.ensureQueryData<AxiosResponse<string>>({
      queryKey: ['labor-accounts', 'certificate-by-self'],
      queryFn: () => axiosInstance.get<string>(endPoint, { headers: { isMock: params.mockAuthVerification } }),
      ...queryConfig,
      gcTime: 0,
    });

    return requestHelper(() => query, onSuccess, onError);
  };

  return requestSelfCertificate;
};
